import { apiConfig } from '@structura/services'

// Identity flows go to the CENTRAL auth service (StructuraMatrix.Auth) when
// VITE_AUTH_URL is set (each app's committed .env.production). Unset — dev,
// tests — they fall back to the app's own /api/auth/* on the app origin,
// which serves the same contract. App-owned endpoints always stay on
// apiConfig.baseUrl.
const authUrlEnv: string = typeof import.meta.env.VITE_AUTH_URL === 'string' ? import.meta.env.VITE_AUTH_URL : ''
const authAppIdEnv: string = typeof import.meta.env.VITE_AUTH_APP_ID === 'string' ? import.meta.env.VITE_AUTH_APP_ID : ''

const trimmedAuthUrl: string = authUrlEnv.trim()
const trimmedAppId: string = authAppIdEnv.trim()

export const authBaseUrl: string = trimmedAuthUrl.length > 0 ? trimmedAuthUrl.replace(/\/$/, '') : apiConfig.baseUrl

// This app's id in the central service's app registry. The mail-sending
// endpoints (register, forgot-password) require it so e-mails carry the
// app's name and link back to this app's origin. Undefined in dev/test,
// where the local fallback backend ignores it.
export const authAppId: string | undefined = trimmedAppId.length > 0 ? trimmedAppId : undefined
